import React from "react"
import styles from "./seperator.module.scss"

export default function Seperator() {
  return <hr className={styles.seperator} />
}
